module.exports = __webpack_public_path__ + "img/assessment-risk.621613de.png";